<div *ngIf="documentoPac">    
    <div class="row">
        <div class="col-sm-10 col-10">
            <span>
                <h1>Detalhe da PAC {{(numeroPacToString | bnMask: '99.999-9') || '-'}}/{{documentoPac.dataAprovacao | date: 'yyyy'}}</h1>
            </span>
        </div>
        <div class="col-sm-2 col-2">
            <button class="btn" (click)="expandir()">
                <i class="fa fa-compress"  aria-hidden="true" *ngIf="labelButton === 'Colapsar'"></i>
                <i class="fa fa-arrows-alt" aria-hidden="true" *ngIf="labelButton === 'Expandir'"></i>
                {{labelButton}}</button>
        </div>
    </div>
    <div class="card shadow-sm">
        <div class="card-header grad" (click)="expadirBloco('informacoespac')">
            <h5>Informações da PAC</h5>
        </div>
        <div id="informacoespac" class="collapse">
            <div class="card-body">
                <app-informacoes-gerais-operacao [documentoPac]="documentoPac"></app-informacoes-gerais-operacao>
            </div>
        </div>
    </div>
    
    <div class="card">
        <div class="card-header grad" (click)="expadirBloco('informacoescompradora')">
            <h5>Informações da Compradora</h5>
        </div>
        <div id="informacoescompradora" class="collapse">
            <div class="card-body">
                <app-informacoes-da-compradora [documentoPac]="documentoPac"></app-informacoes-da-compradora>
            </div>
        </div>
    </div>
    
    <div class="card">
        <div class="card-header grad" (click)="expadirBloco('informacoesfabricante')">
            <h5>Informações da Fabricante</h5>
        </div>
        <div id="informacoesfabricante" class="collapse">
            <div class="card-body">
                <app-informacoes-da-fabricante [documentoPac]="documentoPac"></app-informacoes-da-fabricante>
            </div>
        </div>
    </div>
    
    <div class="card">
        <div class="card-header grad" (click)="expadirBloco('informacoesinvestimento')">
            <h5>Informações do Investimento</h5>
        </div>
        <div id="informacoesinvestimento" class="collapse">
            <div class="card-body">
                <app-informacoes-do-investimento [documentoPac]="documentoPac"></app-informacoes-do-investimento>
            </div>
        </div>
    </div>
    
    <div class="card">
        <div class="card-header grad" (click)="expadirBloco('informacoesoperacaogarantia')">
            <h5>Informações de Operação e Garantia</h5>
        </div>
        <div id="informacoesoperacaogarantia" class="collapse">
            <div class="card-body">
                <app-informacoes-da-operacao-e-garantias [documentoPac]="documentoPac"></app-informacoes-da-operacao-e-garantias>
            </div>
        </div>
    </div>
    
    <div class="card">
        <div class="card-header grad" (click)="expadirBloco('informacoesequipamentos')">
            <h5>Informações de Equipamentos</h5>
        </div>
        <div id="informacoesequipamentos" class="collapse">
            <div class="card-body">
                <app-informacoes-equipamentos [documentoPac]="documentoPac"></app-informacoes-equipamentos>
            </div>
        </div>
    </div>
    
    <!-- <div class="card" *ngIf="isExibirAnaliseCondicionadas">
        <div class="card-header grad" (click)="expadirBloco('informacoesAnaliseCondicionadas')">
            <h5>Informações sobre Análise das Condicionadas</h5>
        </div>
        <div id="informacoesAnaliseCondicionadas" class="collapse">
            <div class="card-body">
                <app-analise-condicionadas [documentoPac]="documentoPac"></app-analise-condicionadas>
            </div>
        </div>
    </div> -->
    
    <div class="card">
        <div class="card-header grad" (click)="expadirBloco('informacoesanexos')">
            <h5>Arquivos Anexados </h5>
        </div>
        <div id="informacoesanexos" class="collapse">
            <div class="card-body">
                <app-informacoes-dos-anexos [documentoPac]="documentoPac"></app-informacoes-dos-anexos>
            </div>
        </div>
    </div>
    
    <div class="card">
        <div class="card-header grad" (click)="expadirBloco('informacoespedidoliberacao')">
            <h5>Informações dos Pedidos de Liberação</h5>
        </div>
        <div id="informacoespedidoliberacao" class="collapse">
            <div class="card-body">
                <app-informacoes-pedidos-liberacao (exibirAnaliseCondicionadasEmitter)="exibirAnaliseCondicionadas($event)" [documentoPac]="documentoPac"></app-informacoes-pedidos-liberacao>
            </div>
        </div>
    </div>
    
    <div class="card">
        <div class="card-header grad" (click)="expadirBloco('informacoesaditivos')">
                <h5>Informações do Aditivo</h5>
        </div>
        <div id="informacoesaditivos" class="collapse">
            <div class="card-body">
                <app-informacoes-de-aditivos [documentoPac]="documentoPac"></app-informacoes-de-aditivos>
            </div>
        </div>
    </div>
    
    <div class="card" *ngIf="exibirHistoricoPac">
        <div class="card-header grad" (click)="expadirBloco('informacoeshistorico')">
            <h5>Informações do Histórico da PAC</h5>
        </div>
        <div id="informacoeshistorico" class="collapse" data-parent="#accordion"
            [ngClass]="labelButton === 'Expandir' ? 'collapse' : 'collapse show'">
            <div class="card-body">
                <app-informacoes-do-historico [documentoPac]="documentoPac"></app-informacoes-do-historico>
            </div>
        </div>
    </div>
    
    <div class="card">
        <div class="card-header grad" (click)="expadirBloco('informacoescancelamentosaldo')">
            <h5>Informações de Cancelamento de Saldo</h5>
        </div>
        <div id="informacoescancelamentosaldo" class="collapse">
            <div class="card-body">
                <app-informacoes-de-cancelamento-do-saldo [documentoPac]="documentoPac"></app-informacoes-de-cancelamento-do-saldo>
            </div>
        </div>
    </div>
</div>
